import { v4 } from "uuid";
import { nanoid } from "nanoid";
import { PAYMENT_TYPES } from "../../Common/constants";
import { Payment } from "./Payment";

function getCreditCardTranslations() {
  return [
    {
      language: "es",
      title: "Tarjeta de crédito",
      description: "Tarjeta de crédito",
    },
    {
      language: "eu",
      title: "Kreditu txartela",
      description: "Kreditu txartela",
    },
    {
      language: "en",
      title: "Credit card",
      description: "Credit card",
    },
    {
      language: "ca",
      title: "Targeta de crèdit",
      description: "Targeta de crèdit",
    },
    {
      language: "de",
      title: "Kreditkarte",
      description: "Kreditkarte",
    },
    {
      language: "fr",
      title: "Carte de crédit",
      description: "Carte de crédit",
    },
    {
      language: "it",
      title: "Carta di credito",
      description: "Carta di credito",
    },
    {
      language: "nl",
      title: "Kredietkaart",
      description: "Kredietkaart",
    },
    {
      language: "pt",
      title: "Cartão de crédito",
      description: "Cartão de crédito",
    },
    {
      language: "ru",
      title: "кредитная карта",
      description: "кредитная карта",
    },
    {
      language: "kr",
      title: "신용 카드",
      description: "신용 카드",
    },
    {
      language: "dk",
      title: "Kreditkort",
      description: "Kreditkort",
    },
  ];
}

function getOtherPaymentMethodsTranslations() {
  return [
    {
      language: "es",
      title: "Otras formas de pago",
      description: "Métodos de pago disponibles:",
    },
    {
      language: "eu",
      title: "Other payment methods",
      description: "Payment methods availables:",
    },
    {
      language: "en",
      title: "Other payment methods",
      description: "Payment methods availables:",
    },
    {
      language: "ca",
      title: "Other payment methods",
      description: "Payment methods availables:",
    },
    {
      language: "de",
      title: "Other payment methods",
      description: "Payment methods availables:",
    },
    {
      language: "fr",
      title: "Other payment methods",
      description: "Payment methods availables:",
    },
    {
      language: "it",
      title: "Other payment methods",
      description: "Payment methods availables:",
    },
    {
      language: "nl",
      title: "Other payment methods",
      description: "Payment methods availables:",
    },
    {
      language: "pt",
      title: "Other payment methods",
      description: "Payment methods availables:",
    },
    {
      language: "ru",
      title: "Other payment methods",
      description: "Payment methods availables:",
    },
    {
      language: "kr",
      title: "Other payment methods",
      description: "Payment methods availables:",
    },
    {
      language: "dk",
      title: "Other payment methods",
      description: "Payment methods availables:",
    },
  ];
}

export const getValuesPNPPROXY = (propertyTicker: string): Payment => {
  return {
    ticker: "pay_no_pain_proxy",
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.PAY_NO_PAIN_PROXY,
    order: 2,
    minRelease: {
      duration: 0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0,
      chronoUnit: "DAYS",
    },
    paymentPercentage: 0,
    paymentInAdvance: false,
    properties: {
      service: "DAE10256-87EE-458B-B637-FE04B8CD7C98",
      apiKey: "16063833b16f44c1bfa99764df4614b0",
      signature: "ETJruEVsX1Y4Sxigihvi9W9N",
      template: "5B82DBB2-DE30-4694-BE27-B03E75319EF8",
      chargeDeposit: "false",
      secure: "false",
    },
    active: true,
    translations: [
      {
        language: "es",
        title: "Tarjeta de crédito como garantía",
        description:
          "La tarjeta de crédito sirve como garantía y se empleará de acuerdo con las condiciones de servicio.",
      },
      {
        language: "de",
        title: "Kreditkarte (als Sicherheit)",
        description:
          "Ihre Kreditkarte dient als Garantie und wird gemäß den Service-Bedingungen verwendet werden.",
      },
      {
        language: "eu",
        title: "kreditu txartela berme bezala",
        description:
          "Kreditu-txartelak berme gisa balio du eta zerbitzuen baldintzen arabera erabiliko da.",
      },
      {
        language: "ko",
        title: "개런티를 위한 신용카드 정보",
        description: "신용카드 정보는 서비스 이용 약관에 따라 개런티 목적으로 사용됩니다",
      },
      {
        language: "ru",
        title: "кредитная карта в качестве гарантии",
        description:
          "Ваша кредитная карта служит гарантией и будет использоваться в соответствии с условиями эксплуатации.",
      },
      {
        language: "ca",
        title: "Tarjeta de crédito como garantía",
        description:
          "La targeta de crèdit serveix com a garantia i s'utilitza d'acord amb les condicions de servei.",
      },
      {
        language: "pt",
        title: "Cartão de crédito como garantia",
        description:
          "Seu cartão de crédito serve como garantia e será usado de acordo com os termos e condições do serviço.",
      },
      {
        language: "fr",
        title: "Carte de crédit comme garantie",
        description:
          "Votre carte de crédit sert de garantie et sera utilisée conformément aux termes et conditions du service.",
      },
      {
        language: "en",
        title: "Credit card as a guarantee",
        description:
          "Your credit card serves as a guarantee and will be used according to the service terms and conditions.",
      },
      {
        language: "it",
        title: "Carta di credito come garanzia",
        description:
          "La carta di credito serve come garanzia e verrà utilizzato in base ai termini e alle condizioni di servizio.",
      },
      {
        language: "nl",
        title: "Creditcard als garantie",
        description:
          "Uw creditcard dient als garantie en zal worden gebruikt in overeenstemming met de service v",
      },
    ],
    restrictions: {},
  };
};

export const getValuesWithoutCard = (propertyTicker: string): Payment => {
  return {
    ticker: "without_card",
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.WITHOUT_CARD,
    order: 2,
    minRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    paymentPercentage: 0.0,
    paymentInAdvance: false,
    properties: {
      roomLockHours: "-1",
      chargeDeposit: "false",
      automaticCancellation: "false",
    },
    active: true,
    translations: [
      {
        language: "es",
        title: "Reserva sin tarjeta",
        description: "Realiza la reserva sin necesidad de depositar ninguna tarjeta de crédito.",
      },
      {
        language: "eu",
        title: "Kreditu txartelik gabeko liburua",
        description: "Realiza la reserva sin necesidad de depositar ninguna tarjeta de crédito.",
      },
      {
        language: "en",
        title: "Book without credit card",
        description: "Realiza la reserva sin necesidad de depositar ninguna tarjeta de crédito.",
      },
      {
        language: "ca",
        title: "Reserva sense targeta de crèdit",
        description: "Realiza la reserva sin necesidad de depositar ninguna tarjeta de crédito.",
      },
      {
        language: "de",
        title: "Buchen Sie ohne Kreditkarte",
        description: "Realiza la reserva sin necesidad de depositar ninguna tarjeta de crédito.",
      },
      {
        language: "fr",
        title: "Livre sans carte de crédit",
        description: "Realiza la reserva sin necesidad de depositar ninguna tarjeta de crédito.",
      },
      {
        language: "it",
        title: "Prenota senza carta di credito",
        description: "Realiza la reserva sin necesidad de depositar ninguna tarjeta de crédito.",
      },
      {
        language: "nl",
        title: "Boek zonder creditcard",
        description: "Realiza la reserva sin necesidad de depositar ninguna tarjeta de crédito.",
      },
      {
        language: "pt",
        title: "Reserve sem cartão de crédito",
        description: "Realiza la reserva sin necesidad de depositar ninguna tarjeta de crédito.",
      },
      {
        language: "ru",
        title: "Забронировать без кредитной карты",
        description: "Realiza la reserva sin necesidad de depositar ninguna tarjeta de crédito.",
      },
      {
        language: "ko",
        title: "신용 카드없이 예약하기",
        description: "Realiza la reserva sin necesidad de depositar ninguna tarjeta de crédito.",
      },
      {
        language: "da",
        title: "Book uden kreditkort",
        description: "Realiza la reserva sin necesidad de depositar ninguna tarjeta de crédito.",
      },
    ],
    restrictions: {},
  };
};

export const getValuesReservationRequest = (propertyTicker: string): Payment => {
  return {
    ticker: "reservation_request",
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.RESERVATION_REQUEST,
    order: 2,
    minRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    paymentPercentage: 0.0,
    paymentInAdvance: false,
    properties: {
      roomLockHours: "0",
      chargeDeposit: "false",
      automaticCancellation: "true",
    },
    active: true,
    translations: [
      {
        language: "es",
        title: "Solicitud de reserva",
        description:
          "Nos pondremos en contacto lo más pronto posible para completar la solicitud de reserva.",
      },
      {
        language: "eu",
        title: "Booking request",
        description:
          "Nos pondremos en contacto lo más pronto posible para completar la solicitud de reserva.",
      },
      {
        language: "en",
        title: "Booking request",
        description:
          "Nos pondremos en contacto lo más pronto posible para completar la solicitud de reserva.",
      },
      {
        language: "ca",
        title: "Booking request",
        description:
          "Nos pondremos en contacto lo más pronto posible para completar la solicitud de reserva.",
      },
      {
        language: "de",
        title: "Booking request",
        description:
          "Nos pondremos en contacto lo más pronto posible para completar la solicitud de reserva.",
      },
      {
        language: "fr",
        title: "Booking request",
        description:
          "Nos pondremos en contacto lo más pronto posible para completar la solicitud de reserva.",
      },
      {
        language: "it",
        title: "Booking request",
        description:
          "Nos pondremos en contacto lo más pronto posible para completar la solicitud de reserva.",
      },
      {
        language: "nl",
        title: "Booking request",
        description:
          "Nos pondremos en contacto lo más pronto posible para completar la solicitud de reserva.",
      },
      {
        language: "pt",
        title: "Booking request",
        description:
          "Nos pondremos en contacto lo más pronto posible para completar la solicitud de reserva.",
      },
      {
        language: "ru",
        title: "Booking request",
        description:
          "Nos pondremos en contacto lo más pronto posible para completar la solicitud de reserva.",
      },
      {
        language: "ko",
        title: "Booking request",
        description:
          "Nos pondremos en contacto lo más pronto posible para completar la solicitud de reserva.",
      },
      {
        language: "da",
        title: "Booking request",
        description:
          "Nos pondremos en contacto lo más pronto posible para completar la solicitud de reserva.",
      },
    ],
    restrictions: {},
  };
};

export const getValuesPNPVersion2 = (propertyTicker: string): Payment => {
  return {
    ticker: "pay_no_pain_v2",
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.PAY_NO_PAIN_V2,
    order: 2,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    paymentPercentage: 0.0,
    paymentInAdvance: false,
    properties: {
      chargeDeposit: "true",
      secure: "false",
      multiAcquirers: "false",
    },
    active: true,
    translations: [
      {
        language: "es",
        title: "Tarjeta de crédito",
        description:
          "La tarjeta de crédito sirve como garantía y se empleará de acuerdo con las condiciones de servicio.",
        descriptionWithDeposit:
          "La forma de pago será mediante pasarela de pago y serán aceptadas las tarjetas",
        descriptionWithoutDeposit:
          "La tarjeta de crédito sirve como <b>garantia de pago</b> y <b>sólo se empleará en caso de cancelación</b> de acuerdo con las condiciones de servicio.",
      },
      {
        language: "eu",
        title: "Kreditu txartela",
        description:
          "Kreditu-txartelak berme gisa balio du eta zerbitzuen baldintzen arabera erabiliko da.",
        descriptionWithDeposit:
          "Ordainketa modua ordainketa-pasabide bidez izango da eta txartelak onartuak izando dira",
        descriptionWithoutDeposit:
          "Kreditu-txartelak berme gisa balio du eta zerbitzuen baldintzen arabera erabiliko da.",
      },
      {
        language: "en",
        title: "Credit card",
        description:
          "Your credit card serves as a guarantee and will be used according to the service terms and conditions.",
        descriptionWithDeposit:
          "Payment is made through a payment gateway and the following cards will be accepted",
        descriptionWithoutDeposit:
          "Your credit card acts as a <b>payment guarantee</b> to cover cancelation or no-show costs acording to the service terms and conditions.",
      },
      {
        language: "ca",
        title: "Targeta de crèdit",
        description:
          "La targeta de crèdit serveix com a garantia i s'utilitza d'acord amb les condicions de servei.",
        descriptionWithDeposit:
          "La forma de pagament serà mitjançant passarel.la de pagament i seran acceptades les targetes",
        descriptionWithoutDeposit:
          "La targeta de crèdit serveix com a <b>garantia</b> de <b>pagament</b> i només s'emprarà en cas de cancel·lació d'acord amb les condicions de servei.",
      },
      {
        language: "de",
        title: "Kreditkarte",
        description:
          "Ihre Kreditkarte dient als Garantie und wird gemäß den Service-Bedingungen verwendet werden.",
        descriptionWithDeposit:
          "Sie können bequem online mit Kreditkarte zahlen. Wir akzeptieren die folgenden Kreditkarten",
        descriptionWithoutDeposit:
          "Ihre Kreditkarte dient als <b>Zahlungsgarantie</b> für Stornierungen oder No-Show-Kosten, wie in den Stornierungsbedindungen angeben.",
      },
      {
        language: "fr",
        title: "Carte de crédit",
        description:
          "Votre carte de crédit sert de garantie et sera utilisée conformément aux termes et conditions du service.",
        descriptionWithDeposit:
          "Le paiement s'effectuera en ligne et les cartes acceptées sont les suivantes",
        descriptionWithoutDeposit:
          "Votre carte de crédit tient lieu de <b>garantie de paiement </b> et <b>elle ne sera utilisée qu’en cas d’annulation </b>conformément aux conditions de service.",
      },
      {
        language: "it",
        title: "Carta di credito",
        description:
          "La carta di credito serve come garanzia e verrà utilizzato in base ai termini e alle condizioni di servizio.",
        descriptionWithDeposit:
          "Il pagamento viene effettuato attraverso un gateway di pagamento e le seguenti carte saranno accettate",
        descriptionWithoutDeposit:
          "La tua carta di credito funge da <b>garanzia di pagamento</b> a copertura cancellazione o no-show costi acording i termini e le condizioni di servizio.",
      },
      {
        language: "nl",
        title: "Kredietkaart",
        description:
          "Uw creditcard dient als garantie en zal worden gebruikt in overeenstemming met de servicevoorwaarden",
        descriptionWithDeposit:
          "De betaling gebeurt via een betalingsgateway en de volgende kaarten worden geaccepteerd",
        descriptionWithoutDeposit:
          "Uw creditcard is nodig om uw reservering te garanderen. U hoeft geen aanbetaling te doen.",
      },
      {
        language: "pt",
        title: "Cartão de crédito",
        description:
          "Seu cartão de crédito serve como garantia e será usado de acordo com os termos e condições do serviço.",
        descriptionWithDeposit:
          "O pagamento é feito através de um gateway de pagamento e os seguintes cartões serão aceitos",
        descriptionWithoutDeposit:
          "O seu cartão de crédito é necessário porque irá garantir a sua reserva. Não será cobrado nenhum depósito.",
      },
      {
        language: "ru",
        title: "кредитная карта",
        description:
          "Ваша кредитная карта служит гарантией и будет использоваться в соответствии с условиями эксплуатации.",
        descriptionWithDeposit:
          "Оплата производится через платежный шлюз и следующие карты будут приниматься",
        descriptionWithoutDeposit:
          "Ваша кредитная карта действует как <b> гарантия оплаты </ b>, чтобы покрыть расходы на аннулирование или неприбытия в соответствии с условиями обслуживания.",
      },
      {
        language: "kr",
        title: "신용 카드",
        description: "신용카드 정보는 서비스 이용 약관에 따라 개런티 목적으로 사용됩니다",
        descriptionWithDeposit:
          "결제 서버를 통해 지불이 완료되었습니다. 다음 신용카드가 승인될 예정입니다.",
        descriptionWithoutDeposit:
          "귀하의 신용 카드는 서비스 이용 약관에 따라 취소 또는 no-show 비용을 위한 <b> 지불 보증 </ b>의 역할을합니다.",
      },
      {
        language: "dk",
        title: "Kreditkort",
        description:
          "Kreditkortet fungerer som en garanti og vil blive brugt i overensstemmelse med servicevilkårene.",
        descriptionWithDeposit:
          "Betaling sker via en sikker forbindelse, og følgende kort accepteres",
        descriptionWithoutDeposit:
          "Dit kreditkort fungerer som en <b> betalingsgaranti </b> til at dække afbestillings- og udeblivelsesomkostninger i henhold til de gældende vilkår og betingelser.",
      },
    ],
    restrictions: {},
  };
};

export const getValuesTransfer = (propertyTicker: string): Payment => {
  return {
    ticker: "tr",
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.TRANSFER,
    order: 2,
    minRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    paymentPercentage: 0.0,
    paymentInAdvance: false,
    properties: {
      roomLockHours: "48",
      automaticCancellation: "true",
    },
    active: true,
    translations: [
      {
        language: "es",
        title: "Transferencia",
        description: "<p>Las instrucciones se enviar&aacute;n por email.</p>",
      },
      {
        language: "en",
        title: "Wire transfer",
        description: "<p>You will receive instructions in your email.</p>",
      },
    ],
    restrictions: {},
  };
};

export const getValuesTPV = (propertyTicker: string): Payment => {
  return {
    ticker: `tpv_${v4()}`,
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.POS,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: {
      clave256: "",
      Ds_Merchant_MerchantCode: "",
      Ds_Merchant_Terminal: "001",
      Ds_Merchant_Currency: "978",
      Ds_Merchant_MerchantURL: `https://engine.witbooking.com/api/payments/tpv/redsys/${propertyTicker}`,
      url: "https://sis-t.redsys.es:25443/sis/realizarPago",
      chargeDeposit: "true",
      Ds_Merchant_Amount: "{total}",
      Ds_Merchant_Order: "{idpedido}",
      Ds_Merchant_PayMethods: "C",
      Ds_Merchant_TransactionType: "0",
      tipo: "sermepa",
      allowTokenize: "false",
    },
    active: false,
    translations: [
      {
        language: "en",
        title: "Credit card (online payment)",
        description:
          "<p>Payment is made through a payment gateway and the following cards will be accepted</p>",
      },
      {
        language: "ca",
        title: "Targeta de crèdit (pagament en línia)",
        description:
          "<p>La forma de pagament ser&agrave; mitjan&ccedil;ant passarel.la de pagament i seran acceptades les targetes</p>",
      },
      {
        language: "es",
        title: "Tarjeta de crédito (Pago en línea)",
        description:
          "<p>La forma de pago ser&aacute; mediante pasarela de pago y ser&aacute;n aceptadas las tarjetas</p>",
      },
    ],
    restrictions: {},
  };
};

export const getValuesTCGarantia = (propertyTicker: string): Payment => {
  return {
    ticker: "tcgarantia",
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.CREDIT_CARD_VAULT,
    order: 0,
    minRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    paymentPercentage: 0.0,
    paymentInAdvance: false,
    properties: {
      chargeDeposit: "true",
    },
    active: true,
    translations: [
      {
        language: "ca",
        title: "Targeta de crèdit com a garantia",
        description:
          "<p>La targeta de cr&egrave;dit serveix com a garantia i s&#39;utilitza d&#39;acord amb les condicions de servei.</p>",
      },
      {
        language: "es",
        title: "Tarjeta de crédito como garantía",
        description:
          "<p>La tarjeta de cr&eacute;dito sirve como garant&iacute;a y se emplear&aacute; de acuerdo con las condiciones de servicio.</p>",
      },
      {
        language: "en",
        title: "Credit card as a guarantee",
        description:
          "<p>Your credit card serves as a guarantee and will be used according to the service terms and conditions.</p>",
      },
    ],
    restrictions: {},
  };
};
export const getValuesPaypal = (propertyTicker: string): Payment => {
  return {
    ticker: "paypal_ec",
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.PAYPAL_EXPRESS_CHECKOUT,
    order: 6,
    minRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: {},
    active: true,
    translations: [
      {
        language: "ko",
        title: "PayPal",
        description: "페이팔로 결제",
      },
      {
        language: "ca",
        title: "PayPal",
        description: "Pagar amb PayPal",
      },
      {
        language: "pt",
        title: "PayPal",
        description: "Pague com PayPal",
      },
      {
        language: "nl",
        title: "PayPal",
        description: "Betaal met PayPal",
      },
      {
        language: "es",
        title: "PayPal",
        description: "Pagar con PayPal",
      },
      {
        language: "ru",
        title: "PayPal",
        description: "Оплата с PayPal",
      },
      {
        language: "de",
        title: "PayPal",
        description: "Mit PayPal bezahlen",
      },
      {
        language: "it",
        title: "PayPal",
        description: "Paga con PayPal",
      },
      {
        language: "en",
        title: "PayPal",
        description: "Pay with PayPal",
      },
      {
        language: "fr",
        title: "PayPal",
        description: "Payer avec PayPal",
      },
    ],
    restrictions: {},
  };
};

export const getValuesCriptan = (propertyTicker: string): Payment => {
  return {
    ticker: "criptan",
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.CRIPTAN,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "DAYS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: {
      // Credentials must never be hardcoded in the frontend bundle (CWE-798).
      // They are per-merchant values and must be entered by the administrator.
      secret: "",
      apiKey: "",
      chargeDeposit: "true",
    },
    active: true,
    translations: [
      {
        language: "es",
        title: "Criptan",
        description: "Pagar con criptomoneda",
        descriptionWithDeposit: "Pagar con criptomoneda",
        descriptionWithoutDeposit: "Pagar con criptomoneda",
      },
      {
        language: "eu",
        title: "Criptan",
        description: "Ordaindu kriptokonferentziarekin",
        descriptionWithDeposit: "Ordaindu kriptokonferentziarekin",
        descriptionWithoutDeposit: "Ordaindu kriptokonferentziarekin",
      },
      {
        language: "en",
        title: "Criptan",
        description: "Pay with cryptocurrency",
        descriptionWithDeposit: "Pay with cryptocurrency",
        descriptionWithoutDeposit: "Pay with cryptocurrency",
      },
      {
        language: "ca",
        title: "Criptan",
        description: "Pagar amb criptomoneda",
        descriptionWithDeposit: "Pagar amb criptomoneda",
        descriptionWithoutDeposit: "Pagar amb criptomoneda",
      },
      {
        language: "de",
        title: "Criptan",
        description: "Mit PayPal bezahlen",
        descriptionWithDeposit: "Mit PayPal bezahlen",
        descriptionWithoutDeposit: "Mit PayPal bezahlen",
      },
      {
        language: "fr",
        title: "Criptan",
        description: "Payer avec la crypto-monnaie",
        descriptionWithDeposit: "Payer avec la crypto-monnaie",
        descriptionWithoutDeposit: "Payer avec la crypto-monnaie",
      },
      {
        language: "it",
        title: "Criptan",
        description: "Paga con criptovaluta",
        descriptionWithDeposit: "Paga con criptovaluta",
        descriptionWithoutDeposit: "Paga con criptovaluta",
      },
      {
        language: "nl",
        title: "Criptan",
        description: "Betalen met cryptovaluta",
        descriptionWithDeposit: "Betalen met cryptovaluta",
        descriptionWithoutDeposit: "Betalen met cryptovaluta",
      },
      {
        language: "pt",
        title: "Criptan",
        description: "Pague com criptomoeda",
        descriptionWithDeposit: "Pague com criptomoeda",
        descriptionWithoutDeposit: "Pague com criptomoeda",
      },
      {
        language: "ru",
        title: "Criptan",
        description: "Плати криптовалютой",
        descriptionWithDeposit: "Плати криптовалютой",
        descriptionWithoutDeposit: "Плати криптовалютой",
      },
      {
        language: "kr",
        title: "Criptan",
        description: "암호화폐로 결제",
        descriptionWithDeposit: "암호화폐로 결제",
        descriptionWithoutDeposit: "암호화폐로 결제",
      },
      {
        language: "dk",
        title: "Criptan",
        description: "Betal med kryptokurrency",
        descriptionWithDeposit: "Betal med kryptokurrency",
        descriptionWithoutDeposit: "Betal med kryptokurrency",
      },
    ],
    restrictions: {},
  };
};

export const getValuesCheckoutPNP = (propertyTicker: string): Payment => {
  return {
    ticker: `checkout_pnp_${v4()}`,
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.CHECKOUT_PNP,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: {},
    active: true,
    translations: getOtherPaymentMethodsTranslations(),
    restrictions: {},
  };
};

export const getValuesPaycomet = (propertyTicker: string): Payment => {
  return {
    ticker: `paycomet_${v4()}`,
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.PAYCOMET,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: {},
    active: true,
    translations: [
      {
        language: "es",
        title: "Tarjeta de crédito",
        description: "Métodos de pago disponibles:",
      },
      {
        language: "eu",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "en",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "ca",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "de",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "fr",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "it",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "nl",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "pt",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "ru",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "kr",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "dk",
        title: "Credit card",
        description: "Payment methods availables:",
      },
    ],
    restrictions: {},
  };
};

export const getValuesPaycometIvr = (propertyTicker: string): Payment => {
  return {
    ticker: `paycomet_ivr_${v4()}`,
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.PAYCOMET_IVR,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: {},
    active: true,
    translations: [
      {
        language: "es",
        title: "IVR",
        description: "Pago con redirección",
      },
      {
        language: "eu",
        title: "IVR",
        description: "Payment with redirection",
      },
      {
        language: "en",
        title: "IVR",
        description: "Payment with redirection",
      },
      {
        language: "ca",
        title: "IVR",
        description: "Payment with redirection",
      },
      {
        language: "de",
        title: "IVR",
        description: "Payment with redirection",
      },
      {
        language: "fr",
        title: "IVR",
        description: "Payment with redirection",
      },
      {
        language: "it",
        title: "IVR",
        description: "Payment with redirection",
      },
      {
        language: "nl",
        title: "IVR",
        description: "Payment with redirection",
      },
      {
        language: "pt",
        title: "IVR",
        description: "Payment with redirection",
      },
      {
        language: "ru",
        title: "IVR",
        description: "Payment with redirection",
      },
      {
        language: "kr",
        title: "IVR",
        description: "Payment with redirection",
      },
      {
        language: "dk",
        title: "IVR",
        description: "Payment with redirection",
      },
    ],
    restrictions: {},
  };
};

export const getValuesAddonPayments = (propertyTicker: string): Payment => {
  return {
    ticker: `addon_payment_${v4()}`,
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.ADDON_PAYMENTS,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: {},
    active: true,
    translations: [
      {
        language: "es",
        title: "Tarjeta de crédito",
        description: "Métodos de pago disponibles:",
      },
      {
        language: "eu",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "en",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "ca",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "de",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "fr",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "it",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "nl",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "pt",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "ru",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "kr",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "dk",
        title: "Credit card",
        description: "Payment methods availables:",
      },
    ],
    restrictions: {},
  };
};

export const getValuesAdyen = (propertyTicker: string): Payment => {
  return {
    ticker: `adyen_${v4()}`,
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.ADYEN,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: {},
    active: true,
    translations: [
      {
        language: "es",
        title: "Tarjeta de crédito",
        description: "Métodos de pago disponibles:",
      },
      {
        language: "eu",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "en",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "ca",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "de",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "fr",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "it",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "nl",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "pt",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "ru",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "kr",
        title: "Credit card",
        description: "Payment methods availables:",
      },
      {
        language: "dk",
        title: "Credit card",
        description: "Payment methods availables:",
      },
    ],
    restrictions: {},
  };
};

export const getValuesStripe = (propertyTicker: string, existingPayment?: Payment): Payment => {
  return {
    ticker: `stripe_${v4()}`,
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.STRIPE,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: existingPayment?.properties ?? {},
    active: true,
    translations: getCreditCardTranslations(),
    restrictions: {},
  };
};

export const getValuesFreedomPay = (propertyTicker: string): Payment => {
  return {
    ticker: `freedomPay_${v4()}`,
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.FREEDOM_PAY,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: {},
    active: true,
    translations: getCreditCardTranslations(),
    restrictions: {},
  };
};

export const getValuesNemuru = (propertyTicker: string): Payment => {
  return {
    ticker: `nemuru_${v4()}`,
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.NEMURU,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: {},
    active: true,
    translations: [
      {
        language: "es",
        title: "Pago fraccionado",
        description: "Reserva ahora y paga a plazos",
      },
      {
        language: "eu",
        title: "Ordainketa zatitua",
        description: "Erreserbatu orain eta ordaindu zatika",
      },
      {
        language: "en",
        title: "Pay in Instalments",
        description: "Book now and pay in instalments",
      },
      {
        language: "ca",
        title: "Pagament fraccionat",
        description: "Reserva ara i paga a terminis",
      },
      {
        language: "de",
        title: "Geteilte Zahlung",
        description: "Jetzt buchen und in Raten zahlen",
      },
      {
        language: "fr",
        title: "Paiement fractionné",
        description: "Réservez maintenant et payez en plusieurs fois",
      },
      {
        language: "it",
        title: "Pagamento diviso",
        description: "Prenota ora e paga a rate",
      },
      {
        language: "nl",
        title: "Gesplitste betaling",
        description: "Boek nu en betaal in termijnen",
      },
      {
        language: "pt",
        title: "Pagamento dividido",
        description: "Reserve agora e pague em prestações",
      },
      {
        language: "ru",
        title: "Раздельный платеж",
        description: "Забронируйте сейчас и платите в рассрочку",
      },
      {
        language: "kr",
        title: "분할 지불",
        description: "지금 예약하고 할부로 결제하세요",
      },
      {
        language: "dk",
        title: "Opdelt betaling",
        description: "Bestil nu og betal i rater",
      },
    ],
    restrictions: {},
  };
};

export const getValuesSepteoVault = (propertyTicker: string): Payment => {
  return {
    ticker: `septeo_vault_${v4()}`,
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.SEPTEO_VAULT,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: {},
    active: true,
    translations: [
      {
        language: "es",
        title: "Tarjeta de crédito como garantía",
        description:
          "La tarjeta de crédito sirve como garantía y se empleará de acuerdo con las condiciones de servicio.",
      },
      {
        language: "de",
        title: "Kreditkarte (als Sicherheit)",
        description:
          "Ihre Kreditkarte dient als Garantie und wird gemäß den Service-Bedingungen verwendet werden.",
      },
      {
        language: "eu",
        title: "kreditu txartela berme bezala",
        description:
          "Kreditu-txartelak berme gisa balio du eta zerbitzuen baldintzen arabera erabiliko da.",
      },
      {
        language: "ko",
        title: "개런티를 위한 신용카드 정보",
        description: "신용카드 정보는 서비스 이용 약관에 따라 개런티 목적으로 사용됩니다",
      },
      {
        language: "ru",
        title: "кредитная карта в качестве гарантии",
        description:
          "Ваша кредитная карта служит гарантией и будет использоваться в соответствии с условиями эксплуатации.",
      },
      {
        language: "ca",
        title: "Tarjeta de crédito como garantía",
        description:
          "La targeta de crèdit serveix com a garantia i s'utilitza d'acord amb les condicions de servei.",
      },
      {
        language: "pt",
        title: "Cartão de crédito como garantia",
        description:
          "Seu cartão de crédito serve como garantia e será usado de acordo com os termos e condições do serviço.",
      },
      {
        language: "fr",
        title: "Carte de crédit comme garantie",
        description:
          "Votre carte de crédit sert de garantie et sera utilisée conformément aux termes et conditions du service.",
      },
      {
        language: "en",
        title: "Credit card as a guarantee",
        description:
          "Your credit card serves as a guarantee and will be used according to the service terms and conditions.",
      },
      {
        language: "it",
        title: "Carta di credito come garanzia",
        description:
          "La carta di credito serve come garanzia e verrà utilizzato in base ai termini e alle condizioni di servizio.",
      },
      {
        language: "nl",
        title: "Creditcard als garantie",
        description:
          "Uw creditcard dient als garantie en zal worden gebruikt in overeenstemming met de service v",
      },
    ],
    restrictions: {},
  };
};

export const getValuesSepteoPayments = (
  propertyTicker: string,
  existingPayment?: Payment
): Payment => {
  return {
    ticker: `septeo_payments_${nanoid(8)}`,
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.SEPTEO_PAYMENTS,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: existingPayment?.properties ?? {},
    active: true,
    translations: getCreditCardTranslations(),
    restrictions: {},
  };
};

export const getValuesSiPay = (propertyTicker: string, existingPayment?: Payment): Payment => {
  return {
    ticker: `sipay_${v4()}`,
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.SIPAY,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: existingPayment?.properties ?? {},
    active: true,
    translations: getCreditCardTranslations(),
    restrictions: {},
  };
};

export const getValuesPnpSdk = (propertyTicker: string, existingPayment?: Payment): Payment => {
  // Reuse credentials from a sibling PNP_SDK entry, but never its modality/method config:
  // the second entry a property creates is the OTHER modality.
  const { componentType, paymentMethods, ...sharedProperties } = existingPayment?.properties ?? {};

  return {
    ticker: `pnp_sdk_${v4()}`,
    propertyTicker: propertyTicker,
    type: PAYMENT_TYPES.PNP_SDK,
    order: 1,
    minRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    maxRelease: {
      duration: 0.0,
      chronoUnit: "HOURS",
    },
    paymentPercentage: 100.0,
    paymentInAdvance: true,
    properties: sharedProperties,
    active: true,
    translations: getOtherPaymentMethodsTranslations(),
    restrictions: {},
  };
};
